export interface FontValues {
  regular: string;
  bold: string;
  light: string;
}

export const FONT_MAP: Record<string, FontValues> = {
  "Frank New": {
    regular: '"frank_newregular"',
    bold: '"frank_newbold"',
    light: '"frank_newlight"',
  },
  Arial: { regular: "Arial", bold: "Arial", light: "Arial" },
  Calibri: { regular: "Calibri", bold: "Calibri", light: "Calibri" },
  "Open Sans": { regular: '"Open Sans"', bold: '"Open Sans"', light: '"Open Sans"' },
  Roboto: { regular: "Roboto", bold: "Roboto", light: "Roboto" },
  Verdana: { regular: "Verdana", bold: "Verdana", light: "Verdana" },
  Helvetica: { regular: "Helvetica", bold: "Helvetica", light: "Helvetica" },
  "Times New Roman": {
    regular: '"Times New Roman"',
    bold: '"Times New Roman"',
    light: '"Times New Roman"',
  },
};
